<template>
  <div class="ine-card plan-actions">
    <ActionLoader v-if="isLoading" class="plan-actions__loader" />
    <template v-else>
      <p v-if="isPlanFailed" class="plan-actions__failed-message">
        Auto Renewal Failed
        <button
          id="update-payment"
          class="plan-actions__state-btn"
          @click="$emit('update-payment-method')"
        >
          Update Your Payment Method
        </button>
      </p>
      <div class="plan-actions__actions">
        <div
          v-if="isPlanInCancelledState"
          class="plan-actions__reactivate-wrapper"
        >
          <div class="plan-actions__cancel-info">
            <p class="plan-actions__cancel-info--text">
              <AlertTriangleIcon class="plan-actions__cancel-info--icon" />
              Your subscription has been cancelled. You will continue to have
              access until {{ planExpiryDate }}
            </p>
          </div>
          <button
            id="reactivate"
            class="btn btn--primary"
            @click="$emit('reactivate-renewal-clicked')"
          >
            Reactivate Subscription
          </button>
        </div>
        <button
          v-if="canUpgradePlan"
          id="upgrade"
          class="btn btn--primary"
          @click="$emit('upgrade-plan-clicked')"
        >
          Upgrade
        </button>
        <a
          v-if="showContactSupport && !isPlanInCancelledState"
          id="upgrade"
          target="_blank"
          href="mailto:support@ine.com"
          rel="noopener"
          class="btn btn--primary"
        >
          Contact support to upgrade
        </a>
        <button
          v-if="isPlanActive"
          id="cancel"
          class="btn btn--tertiary"
          @click="$emit('cancel-renewal-clicked')"
        >
          Cancel subscription renewal
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import AlertTriangleIcon from '@/assets/icons/subscriptions/alert-triangle.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'PlanActions',
  components: {
    ActionLoader,
    AlertTriangleIcon: { ...AlertTriangleIcon, name: 'AlertTriangleIcon' },
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isPlanActive: {
      type: Boolean,
      required: true,
    },
    isPlanFailed: {
      type: Boolean,
      required: true,
    },
    isPlanInCancelledState: {
      type: Boolean,
      required: true,
    },
    planExpiryDate: {
      type: String,
      required: true,
    },
    plan: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      plansCannotUpgrade: [
        CONSTANTS.PLANS.ALL.ejptv2_funda_monthly,
        CONSTANTS.PLANS.ALL.eda_premium,
        CONSTANTS.PLANS.ALL.eda_premium_cont,
      ],
    }
  },
  computed: {
    ...mapState({
      validPlans: state => state.subscriptions.validPlans,
      isUpgradePlanAllowed: state => state.subscriptions.isUpgradePlanAllowed,
    }),
    canUpgradePlan() {
      return (
        this.isPlanActive &&
        this.plan.valid_plans?.length &&
        !this.plansCannotUpgrade.includes(this.plan.code) &&
        this.isUpgradePlanAllowed
      )
    },
    showContactSupport() {
      return this.plansCannotUpgrade.includes(this.plan.plan_code)
    },
  },
}
</script>

<style lang="scss">
.plan-actions {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  min-height: 75px;
  border-radius: 0 0 5px 5px;
  @include mobile {
    padding: 10px;
    justify-content: flex-end;
  }
  &__loader {
    position: absolute;
    right: 25px;
  }
  &__failed-message {
    color: var(--red);
    font-size: rem(16px);
    font-family: var(--font-bold);
  }
  &__reactivate-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  &__actions {
    width: 100%;
    button {
      width: 100%;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    @include mobile {
      display: flex;
      flex-direction: row-reverse;
      button {
        width: fit-content;
        margin-bottom: 0;
        margin-left: 20px;
        &:last-child {
          margin-bottom: 0;
          margin-left: 0;
        }
      }
    }
  }
  &__cancel-info {
    margin: 0 25px 0 0;
    &--text {
      display: flex;
      align-items: center;
      color: var(--white);
      margin: 0;
      padding: 0;
      @include desktop {
        white-space: nowrap;
      }
    }
    &--icon {
      fill: var(--orange);
      height: 40px;
      width: 30px;
      margin: 0 5px 0 0;
      display: none;
      @include mobile {
        display: block;
      }
    }
  }
}
</style>
